var _path, _g, _path2, _g2, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2238_41236",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3H2V21L20 3Z",
    fill: "#231448"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2238_41236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 11.9715C5.64706 7.77209 13.0588 0.94827 21 11.9715C13.3765 22.8897 5.82353 16.5207 3 11.9715Z",
    stroke: "#0A173D",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3.4,
    stroke: "#0A173D",
    strokeWidth: 1.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2238_41236",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 18,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22L22 22L22 4L4 22Z",
    fill: "#231448"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2238_41236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 11.9715C5.64706 7.77209 13.0588 0.94827 21 11.9715C13.3765 22.8897 5.82353 16.5207 3 11.9715Z",
    stroke: "#0A173D",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3.4,
    stroke: "#0A173D",
    strokeWidth: 1.2
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18.9807,
    y1: 3.42426,
    x2: 3.42431,
    y2: 18.9806,
    stroke: "#0A173D",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewOff);
export default __webpack_public_path__ + "static/media/view_off.357288c662f818aea392beb9f6ff81f9.svg";
export { ForwardRef as ReactComponent };